import {RouterModule, Routes} from "@angular/router";
import {JoinComponent} from "../component/join/join.component";
import {MainComponent} from "../component/main/main.component";

const routes: Routes = [
    { path: "", component: MainComponent },
    { path: "join", component: JoinComponent },
    { path: "main", component: MainComponent },
    { path: "**", component: MainComponent }
];

export const RouterSetting = RouterModule.forRoot(routes, {useHash: true});
